import type { Theme, TextScale } from '../theme'

/**
 * The two Appearance option lists — colour scheme and text size. Shared by TopBar's account-menu
 * popover (compact, roving-tabindex `menuitemradio` groups) AND the standalone Appearance section
 * of the global Settings page (plain `<fieldset>` radios): ONE source for the data + labels, so the
 * two surfaces can never drift out of sync on what the options are, even though each renders and
 * navigates them with its own (very different) interaction code.
 */

export type ThemeLabel = 'theme_light' | 'theme_dark' | 'theme_high_contrast' | 'theme_system'
export const THEMES: { id: Theme; label: ThemeLabel }[] = [
  { id: 'light', label: 'theme_light' },
  { id: 'dark', label: 'theme_dark' },
  { id: 'high-contrast', label: 'theme_high_contrast' },
  { id: 'system', label: 'theme_system' },
]

export type TextScaleLabel = 'textscale_default' | 'textscale_large' | 'textscale_xlarge' | 'textscale_xxlarge'
export const TEXT_SCALES: { id: TextScale; label: TextScaleLabel }[] = [
  { id: 'default', label: 'textscale_default' },
  { id: 'large', label: 'textscale_large' },
  { id: 'x-large', label: 'textscale_xlarge' },
  { id: 'xx-large', label: 'textscale_xxlarge' },
]
